import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { links, constants } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import ModalWithActions from 'components/modal/ModalWithActions/ModalWithActions'

import messages from './messages'


export default class ResubscribeWithDiscountModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
  }

  static defaultProps = {
    name: constants.modals.resubscribe.ResubscribeWithDiscount,
    title: messages.title,
  }

  constructor() {
    super()

    this.actions = [
      {
        brand: true,
        title: messages.btnJoinTheClub,
        onClick: this.handleClickResubscribe,
        key: 'btnJoinTheClub',
        id: 'btnJoinTheClub',
      },
      {
        whiteGray: true,
        title: messages.btnNoThanks,
        onClick: this.close,
        key: 'btnNoThanks',
        id: 'btnNoThanks',
      },
    ]
  }

  handleClickResubscribe = () => {
    actions.models.subscription.resubscribe({
      resubscribeCode: constants.resubscribeTypes.resub50,
      successModal: constants.modals.resubscribe.SuccessfullyResubscribed,
      popup: constants.analyticsEvents.resubscribePopup.resubscribeWithDiscount,
    })
      .catch(() => {
        actions.misc.cookies.removeItem(constants.cookieNames.offer)
        actions.misc.cookies.setSessionItem(constants.cookieNames.resubscribeCode, 'resub50')

        actions.models.router.push(
          `${links.subscribe}?resubscribeCode=${constants.resubscribeTypes.resub50}`
        )
      })
      .finally(this.close)
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, title } = this.props

    return (
      <ModalWithActions
        id={name}
        name={name}
        title={title}
        actions={this.actions}
      >
        <FormattedHTMLMessage tag="div" {...messages.text} />
      </ModalWithActions>
    )
  }
}
